var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProformaInvoicesIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Group 1015"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h48v48H0V0z",
    "data-name": "Rectangle 202"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M12 12h24v24H12V12z",
    "data-name": "Rectangle 17967"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fff",
    d: "M32.638 12.39H16.672a2.66 2.414 0 00-2.66 2.415v19.31a2.66 2.414 0 002.66 2.414h15.966a2.66 2.414 0 002.66-2.414V17.218l-2.66-4.827zm-13.305 2.415h10.644v2.413h2.66v16.897H16.673v-19.31h2.661zm3.992 6.034h7.982v2.414h-7.982v-2.414zm0 3.62h7.982v2.415h-7.982V24.46zm0 3.621h5.322v2.414h-5.322V28.08z",
    "data-name": "Path 31527"
  })));
}

export default SvgProformaInvoicesIcon;